<template>
    <b-modal id="modal-crosseling" size="lg" hide-footer hide-header centered title="Přidáno do košíku">
        <div class="box-popup-crosseling" v-if="lastAddedBasketItem">
            <div class="box-popup-crosseling__header">
                <svg class="bi mr-3" width="35px" height="40px">
                    <use xlink:href="/images/icons/bootstrap-icons.svg#check2-circle" />
                </svg>
                Zboží vloženo do košíku
            </div>

            <div class="box-popup-crosseling__content">
                <div class="box-popup-crosseling__product">
                    <div class="box-popup-crosseling__product__name" data-attr="Název">
                        <span class="box-popup-crosseling__product__name--in-mobile">
                            {{lastAddedBasketItem.quantity}}x
                        </span>
                        <div class="box-popup-crosseling__product__text">
                            {{lastAddedBasketItem.productName}}
                        </div>
                    </div>
                    <div class="box-popup-crosseling__product__image" data-attr="Obrázek">
                        <img :src="apiBaseUrl + lastAddedBasketItem.productPictureUrl" alt class="image-product" />
                    </div>
                    <div class="box-popup-crosseling__product__unit" data-attr="Počet">
                        <div class="box-popup-crosseling__product__name-column">
                            Počet
                        </div>
                        <div class="box-popup-crosseling__product__text">
                            {{ lastAddedBasketItem.quantity }}
                        </div>
                    </div>
                    <div class="box-popup-crosseling__product__price" data-attr="Cena za kus">
                        <div class="box-popup-crosseling__product__name-column">
                            Cena za kus
                        </div>
                        <div class="box-popup-crosseling__product__text">
                            {{ lastAddedBasketItem.productPrice  }} Kč
                        </div>
                    </div>
                    <div class="box-popup-crosseling__product__price box-popup-crosseling__product__price--main" data-attr="Cena celkem">
                        <div class="box-popup-crosseling__product__name-column">
                            Cena celkem
                        </div>
                        <div class="box-popup-crosseling__product__text">
                            {{ lastAddedBasketItem.productPrice * lastAddedBasketItem.quantity  }} Kč
                        </div>
                    </div>
                </div>
            </div>

            <div class="box-popup-crosseling__footer">

                <div class="box-popup-crosseling__action">
<!--                    <div class="box-popup-crosseling__action__transport">-->
<!--                        <div class="box-free-transport box-free-transport&#45;&#45;done">-->
<!--                            <div class="box-free-transport__info">-->
<!--                                <svg class="bi mr-3" width="35px" height="40px">-->
<!--                                    <use xlink:href="/images/icons/bootstrap-icons.svg#truck" />-->
<!--                                </svg>-->
<!--                                <span class="box-free-transport__info__text">-->
<!--                                    Doprava zdarma při objednávce nad  <strong class="highlighter">600 Kč</strong>.-->
<!--                                    K dopravě zdarma zbýva nakoupit za <strong class="highlighter">805 Kč</strong>-->
<!--                                </span>-->
<!--                            </div>-->
<!--                            <div class="box-free-transport__progress-bar js-yet-not-implemented">-->
<!--                                <div class="box-free-transport__progress-bar__in" style="width: 80%;"></div>-->
<!--                                <div class="box-free-transport__progress-bar__scale"></div>-->
<!--                                <div class="box-free-transport__progress-bar__scale"></div>-->
<!--                                <div class="box-free-transport__progress-bar__scale"></div>-->
<!--                            </div>-->
<!--                        </div>-->
<!--                    </div>-->
                    <div class="box-actions">
                      <a href="#" @click.prevent="$root.$emit('bv::hide::modal', 'modal-crosseling')" class="box-popup-crosseling__action__btn box-popup-crosseling__action__btn--cancel btn btn-outline btn--icon-left">
                        Pokračovat v nákupu
                      </a>
                        <a href="/cart" class="box-popup-crosseling__action__btn box-popup-crosseling__action__btn--continue btn btn-primary">Přejít do košíku</a>
                    </div>
                </div>
            </div>
        </div>
    </b-modal>
</template>

<script type="text/javascript">

    import { BIcon, BIconArrowRight } from 'bootstrap-vue'
    import { EventBus } from '@/common/utils/event-bus'

    export default {
        components: { BIcon, BIconArrowRight },
        data() {
            return {
                apiBaseUrl: "",
            }
        },
        mounted() {
            EventBus.$on('eshop-cart-item-added', (data) => this.$root.$emit('bv::show::modal', 'modal-crosseling'))
        },
        computed: {
            lastAddedBasketItem() {
                return this.$store.state.cartModule.lastAddedItem;
            }
        },
    }
</script>

<style lang="scss">
    #modal-crosseling .modal-body {
        padding: 0;
    }
    
    .box-popup-crosseling__header {
        width: 100%;
        min-height: 56px;
        line-height: 56px;
        text-align: center;
        font-size: 18px;
        font-weight: 700;
        color: #289b37;
        font-family: 'Roboto';
        background: #fff;
        border-radius: 3px 3px 0 0;
        svg {
            display: inline-block
        }
        /* letter-spacing: 1px; */
    }

    .box-popup-crosseling__product__unit {
        display: none;
        font-weight: 400;
        color: #585857;
        font-family: 'PT Sans',sans-serif;
    }

    .box-popup-crosseling__product {
        display: -webkit-box;
        display: -webkit-flex;
        display: -ms-flexbox;
        display: flex;
        -webkit-box-orient: vertical;
        -webkit-box-direction: normal;
        -webkit-flex-direction: column;
        -ms-flex-direction: column;
        flex-direction: column;
        padding: 22px 20px;
    }

    .box-popup-crosseling__product__name {
        width: 100%;
        line-height: 27px;
        font-size: 0.9rem;
        text-align: center;
        font-weight: bold;
        color: #000;
        font-family: 'Roboto',sans-serif;
    }

    .box-popup-crosseling__product__price {
        display: inline-block;
        width: 100%;
        font-weight: 400;
        color: #000;
        font-family: 'Roboto',sans-serif;
    }

    .box-popup-crosseling__product__price--main {
        font-weight: 700;
    }

    .box-popup-crosseling__footer {
        padding: 12px 12px 12px;
        background: #F6F6F6;
        border-radius: 0 0 3px 3px;
    }

    .box-popup-crosseling__product__image {
        position: relative;
        width: 100%;
        height: 96px;
        margin: 10px 0 10px 0;
    }

        .box-popup-crosseling__product__image img {
            position: absolute;
            top: 0;
            bottom: 0;
            right: 0;
            left: 0;
            margin: auto;
            width: auto;
            height: auto;
            max-width: 100%;
            max-height: 100%;
        }

    .box-popup-crosseling__action {
        display: -webkit-box;
        display: -webkit-flex;
        display: -ms-flexbox;
        display: flex;
        -webkit-box-orient: vertical;
        -webkit-box-direction: normal;
        -webkit-flex-direction: column;
        -ms-flex-direction: column;
        flex-direction: column;
    }

    .box-popup-crosseling__action__btn--continue {
        -webkit-box-flex: 0;
        -webkit-flex: 0 0 30%;
        -ms-flex: 0 0 30%;
        flex: 0 0 30%;
        font-weight: 400;
    }

    .box-popup-crosseling__action__btn--cancel {
        -webkit-box-flex: 0;
        -webkit-flex: 0 0 10%;
        -ms-flex: 0 0 10%;
        flex: 0 0 10%;
        min-height: 32px;
        padding: 8px 15px;
        font-size: 15px;
        font-weight: 400;
        color: #000000;
        border-color: #c1c1c1;
        &:hover {
            color: #000000;
            border-color: #000000;
        }

    }

    .box-free-transport__info {
        display: -webkit-box;
        display: -webkit-flex;
        display: -ms-flexbox;
        display: flex;
        /* -webkit-box-pack: center; */
        -webkit-justify-content: center;
        -ms-flex-pack: center;
        justify-content: center;
        -webkit-box-align: center;
        -webkit-align-items: center;
        -ms-flex-align: center;
        align-items: center;
    }

    .box-free-transport .highlighter {
        color: #000;
    }

    .box-free-transport__info .svg {
        display: inline-block;
        vertical-align: middle;
        margin-right: 10px;
        font-size: 30px;
    }

    .box-free-transport__info__text {
        display: inline-block;
        vertical-align: middle;
        text-align: left;
        line-height: normal;
        font-size: 14px;
        font-family: 'PT Sans',sans-serif;
        color: #585857;
    }

    .box-free-transport__progress-bar {
        position: relative;
        width: 100%;
        height: 10px;
        line-height: 10px;
        margin: 6px auto 0px;
        text-align: left;
        font-size: 0;
        letter-spacing: 0;
        border: 1px solid #D9D9D9;
        border-radius: 24px;
        background: #F6F6F6;
    }

    .box-free-transport__progress-bar__in {
        position: absolute;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        line-height: 24px;
        z-index: 1;
        border-radius: 24px;
        background: #42b350;
    }

    .box-free-transport__progress-bar__scale {
        position: relative;
        top: 50%;
        -webkit-transform: translateY(-30%);
        -ms-transform: translateY(-30%);
        transform: translateY(-30%);
        display: inline-block;
        width: -webkit-calc(100% / 4);
        width: calc(100% / 4);
        height: 5px;
        z-index: 2;
        border-right: 2px solid rgba(0,0,0,0.2);
    }

    @media only screen and (min-width: 769px) {


        .box-popup-crosseling__product__name {
            -webkit-box-flex: 1;
            -webkit-flex: 1 0 20%;
            -ms-flex: 1 0 20%;
            flex: 1 0 20%;
            -webkit-align-self: center;
            -ms-flex-item-align: center;
            -ms-grid-row-align: center;
            align-self: center;
            text-align: left;
        }

        .box-popup-crosseling__product__unit {
            display: block;
            -webkit-box-flex: 1;
            -webkit-flex: 1;
            -ms-flex: 1;
            flex: 1;
            text-align: center;
        }

        .box-popup-crosseling__product__price {
            -webkit-box-flex: 1;
            -webkit-flex: 1;
            -ms-flex: 1;
            flex: 1;
            text-align: center;
        }

        .box-popup-crosseling__product__price {
            -webkit-box-flex: 1;
            -webkit-flex: 1;
            -ms-flex: 1;
            flex: 1;
            text-align: center;
        }

        .box-popup-crosseling__product__name-column {
            display: block;
            margin-bottom: 26px;
            font-size: 0.8rem;
        }

        .box-popup-crosseling__product__text {
            float: none;
        }

        .box-popup-crosseling__product {
            -webkit-box-orient: horizontal;
            -webkit-box-direction: normal;
            -webkit-flex-direction: row;
            -ms-flex-direction: row;
            flex-direction: row;
            padding: 22px 22px 22px 20px;
        }

        .box-popup-crosseling__product__image {
            -webkit-box-flex: 0;
            -webkit-flex: 0 96px;
            -ms-flex: 0 96px;
            flex: 0 96px;
            width: 96px;
            -webkit-box-ordinal-group: 0;
            -webkit-order: -1;
            -ms-flex-order: -1;
            order: -1;
            -webkit-align-self: center;
            -ms-flex-item-align: center;
            -ms-grid-row-align: center;
            align-self: center;
            margin: 0 50px 0 0;
        }

        .box-popup-crosseling__action__transport {
            -webkit-box-flex: 0;
            -webkit-flex: 0 50%;
            -ms-flex: 0 50%;
            flex: 0 50%;
            -webkit-box-ordinal-group: 2;
            -webkit-order: 1;
            -ms-flex-order: 1;
            order: 1;
        }

        .box-popup-crosseling__action__btn--continue {
            -webkit-box-ordinal-group: 2;
            -webkit-order: 1;
            -ms-flex-order: 1;
            order: 1;
        }

        .box-popup-crosseling__action__btn--cancel {
            -webkit-box-ordinal-group: 0;
            -webkit-order: -1;
            -ms-flex-order: -1;
            order: -1;
        }

        .box-popup-crosseling__product__name--in-mobile {
            display: none;
        }
    }

    @media only screen and (min-width: 1024px) {
        .box-free-transport__progress-bar {
            width: 80%;
        }
    }

    @media only screen and (min-width: 480px) {
        .box-popup-crosseling__action {
            -webkit-flex-wrap: wrap;
            -ms-flex-wrap: wrap;
            flex-wrap: wrap;
            -webkit-box-orient: horizontal;
            -webkit-box-direction: normal;
            -webkit-flex-direction: row;
            -ms-flex-direction: row;
            flex-direction: row;
            -webkit-box-align: center;
            -webkit-align-items: center;
            -ms-flex-align: center;
            align-items: center;
            -webkit-box-pack: justify;
            -webkit-justify-content: space-between;
            -ms-flex-pack: justify;
            justify-content: space-between;
          flex-direction: row-reverse;
        }


        .box-popup-crosseling__action__btn--cancel {
            -webkit-box-ordinal-group: 0;
            -webkit-order: -1;
            -ms-flex-order: -1;
            order: -1;
        }
    }
</style>
